import { Heading, VStack, Input, Button, Box, Table, Thead, Tbody, Tr, Th, Td, useToast, Checkbox, Text,useColorModeValue } from '@chakra-ui/react';
import React, { useState, useEffect } from 'react';
import axios from 'axios';
import { Tooltip } from "@chakra-ui/react";
import { FiEdit, FiCheck, FiX, FiTrash } from "react-icons/fi";

interface Tenant {
  tenant_id: number;
  name: string;
  description: string;
  is_active: boolean;
}

interface Lesson {
    id: number;
    planned_class_id: number;
    title: string;
    description: string;
    summary_url?: string; // Optional field
    content_url?: string; // Optional field
    assignment_url?: string; // Optional field
    created_at: Date; // ISO string for date-time
    updated_at: Date; // ISO string for date-time
  };

  interface LessonsTableProps {
    plannedClassId: number; 
  }


const LessonsTable: React.FC<LessonsTableProps> = ({ plannedClassId}) => {
  const [lessons, setLessons] = useState<Lesson[]>([]);
  const [isAddingNew, setIsAddingNew] = useState(false);
  const [editRow, setEditRow] = useState<number | null>(null); // Track the row currently being edited
  const [newLesson, setNewLesson] = useState<Lesson | null>(null);
  const toast = useToast();

  const tableHeaderbg = useColorModeValue("teal.100", "teal.700");

  const buttonBg1 = useColorModeValue(
    'linear-gradient(to right, teal.50, teal.100)',
    'linear-gradient(to right, teal.600, teal.700)'
  );

  const fetchLessons = async () => {
    try {
     

    const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';

      
    const response = await axios.get(apiurl + `/planned-classes/${plannedClassId}/lessons`, {
        headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
        }
    });

      setLessons(response.data);
    } catch (error) {
      console.error("Failed to load lessons", error);
    }
  };

  const handleAddNewLesson = () => {
    setIsAddingNew(true);
    setNewLesson({ id: 0, title: '',description: '',summary_url: '',assignment_url: '', planned_class_id:plannedClassId, content_url: '', created_at: new Date(), updated_at: new Date()});
  };

  const handleRemoveNewLesson = () => {
    setIsAddingNew(false);
    setNewLesson(null);
  };

  const handleSaveLesson = async (lesson: Lesson) => {
    try {

        
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      console.log("Printing Token from Save" + localStorage.getItem("token"));
      const response = await axios.post(apiurl + `/planned-classes/${plannedClassId}/lessons`, lesson, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      setLessons([...lessons, response.data]);
      setIsAddingNew(false);
      setNewLesson(null);
      toast({ title: "Lesson added successfully", status: "success" });
    } catch (error) {
      console.error("Failed to save lesson", error);
      toast({ title: "Failed to add lesson", status: "error" });
    }
  };

  const handleDeleteLesson = async (lesson_id: number) => {
    try {
      const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
    console.log("Printing Token from Delete" + localStorage.getItem("token"));
    await axios.delete(apiurl + `/lessons/${lesson_id}`, {
      headers: {
        Authorization: `Bearer ${localStorage.getItem('token')}`
      }
    });
    fetchLessons();
    setEditRow(null); // Reset edit mode after successful update
    toast({ title: "Lesson deleted successfully", status: "success" });
  } catch (error) {
    console.error("Failed to delete lesson", error);
    toast({ title: "Failed to delete lesson", status: "error" });
  }
  };
  const handleUpdateLesson = async (lesson: Lesson) => {

    try {
        const apiurl = process.env.REACT_APP_API_URL || 'https://default-url.com';
      console.log("Printing Token from Update" + localStorage.getItem("token"));
      await axios.put(apiurl + `/lessons/${lesson.id}`, lesson, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem('token')}`
        }
      });
      fetchLessons();
      setEditRow(null); // Reset edit mode after successful update
      toast({ title: "Lesson updated successfully", status: "success" });
    } catch (error) {
      console.error("Failed to update lesson", error);
      toast({ title: "Failed to update lesson", status: "error" });
    }
  };

  const handleEditRow = (lesson_id: number) => {
    setEditRow(lesson_id);
    setIsAddingNew(false); // Disable add lesson while editing
  };

  
  const handleCancelEdit = () => {
    setEditRow(null);
    setIsAddingNew(false);
  };

  useEffect(() => {
    fetchLessons();
  }, []);

  return (
    <Box >
       <Box >
        <Button colorScheme="teal" borderRadius={"sm"} fontSize="sm" fontWeight="normal" onClick={handleAddNewLesson} isDisabled={isAddingNew || editRow !== null}>
          + Lesson
        </Button>
      </Box>
      <Box mt={1}>
      
        <Table mt={1} borderColor={"gray.300"} borderWidth={1} borderRadius="sm">
          <Thead>
            <Tr backgroundImage={buttonBg1}>
              <Th>ID</Th>
              <Th>Name</Th>
              <Th>Description</Th>
              <Th>Summary URL</Th>
              <Th>Content URL</Th>
              <Th>Assignment URL</Th>
              <Th>Actions</Th>
            </Tr>
          </Thead>
          <Tbody fontSize="sm">
            {lessons.map((lesson) => (
              <Tr key={lesson.id} opacity={editRow && editRow !== lesson.id ? 0.5 : isAddingNew ? 0.5 : 1}>
                <Td>{lesson.id}</Td>
                <Td maxWidth="250px">
                  {editRow === lesson.id ? (
                    <Input
                      size="sm" // Control the input size here
                      fontSize="sm" // Control font size inside input
                      value={lesson.title}
                      onChange={(e) => {
                        lesson.title = e.target.value;
                        setLessons([...lessons]);
                      }}
                    />
                  ) : (
                    lesson.title
                  )}
                </Td>
                <Td maxWidth="250px">
                  {editRow === lesson.id ? (
                    <Input
                      size="sm" // Control the input size here
                      fontSize="sm" // Control font size inside input
                      value={lesson.description}
                      onChange={(e) => {
                        lesson.description = e.target.value;
                        setLessons([...lessons]);
                      }}
                    />
                  ) : (
                    lesson.description
                  )}
                </Td>
                <Td maxWidth="250px">
                  {editRow === lesson.id ? (
                    <Input
                    size="sm" // Control the input size here
                    
                      fontSize="sm" // Control font size inside input
                      value={lesson.summary_url}
                      onChange={(e) => {
                        lesson.summary_url = e.target.value;
                        setLessons([...lessons]);
                      }}
                    />
                  ) : (
                    lesson.summary_url
                  )}
                </Td>
                <Td maxWidth="250px">
                  {editRow === lesson.id ? (
                    <Input
                    size="sm" // Control the input size here
                    maxWidth="250px"
                      fontSize="sm" // Control font size inside input
                      value={lesson.content_url}
                      onChange={(e) => {
                        lesson.content_url = e.target.value;
                        setLessons([...lessons]);
                      }}
                    />
                  ) : (
                    lesson.content_url
                  )}
                </Td>
                <Td maxWidth="250px">
                  {editRow === lesson.id ? (
                    <Input
                    size="sm" // Control the input size here
                    
                      fontSize="sm" // Control font size inside input
                      value={lesson.assignment_url}
                      onChange={(e) => {
                        lesson.assignment_url = e.target.value;
                        setLessons([...lessons]);
                      }}
                    />
                  ) : (
                    lesson.assignment_url
                  )}
                </Td>
                <Td maxWidth="250px">
                  {editRow === lesson.id ? (
                    <>
                      <Tooltip label="Update">
                        <Button size="sm" onClick={() => handleUpdateLesson(lesson)}><FiCheck /></Button>
                      </Tooltip>
                      <Tooltip label="Cancel">
                        <Button size="sm" ml={2} onClick={handleCancelEdit}><FiX /></Button>
                      </Tooltip>
                    </>
                  ) : (
                    <>
                    <Tooltip label="Edit">
                      <Button size="sm" colorScheme="blue" onClick={() => handleEditRow(lesson.id)} mr={8}>
                        <FiEdit />
                      </Button>
                    </Tooltip>
                    <Tooltip label="Delete">
                    <Button
                          size="sm"
                          colorScheme="red"
                          onClick={() => {
                            if (window.confirm("Are you sure you want to delete this lesson?")) {
                              handleDeleteLesson(lesson.id);
                            }
                          }}
                        >
                          <FiTrash />
                        </Button>
                    </Tooltip>
                  </>
                  )}
                </Td>
              </Tr>
            ))}
            {isAddingNew && newLesson && (
              <Tr
              fontSize="sm" // Control font size inside input 
              >
                <Td>New</Td>
                <Td>
                  <Input
                    size="sm" // Control the input size here
                    fontSize="sm" // Control font size inside input
                    value={newLesson.title}
                    onChange={(e) => setNewLesson({ ...newLesson, title: e.target.value })}
                  />
                </Td>
                <Td>
                  <Input
                    size="sm" // Control the input size here
                    fontSize="sm" // Control font size inside input
                    value={newLesson.description}
                    onChange={(e) => setNewLesson({ ...newLesson, description: e.target.value })}
                  />
                </Td>
                <Td>
                  <Input
                    size="sm" // Control the input size here
                    fontSize="sm" // Control font size inside input
                    value={newLesson.summary_url}
                    onChange={(e) => setNewLesson({ ...newLesson, summary_url: e.target.value })}
                  />
                </Td>
                <Td>
                  <Input
                    size="sm" // Control the input size here
                    maxWidth="250px"
                    fontSize="sm" // Control font size inside input
                    value={newLesson.content_url}
                    onChange={(e) => setNewLesson({ ...newLesson, content_url: e.target.value })}
                  />
                </Td>
                <Td>
                  <Input
                    size="sm" // Control the input size here
                    fontSize="sm" // Control font size inside input
                    value={newLesson.assignment_url}
                    onChange={(e) => setNewLesson({ ...newLesson, assignment_url: e.target.value })}
                  />
                </Td>
                <Td>
                  <Tooltip label="Save">
                    <Button size="sm" onClick={() => handleSaveLesson(newLesson)}><FiCheck /></Button>
                  </Tooltip>
                  <Tooltip label="Cancel">
                    <Button size="sm" ml={2} onClick={handleRemoveNewLesson}><FiX /></Button>
                  </Tooltip>
                </Td>
              </Tr>
            )}
          </Tbody>
        </Table>
        
      </Box>
     
    </Box>
  );
};

export default LessonsTable;